import React from 'react';
import { observer } from 'mobx-react';
import { AgGridReact } from 'ag-grid-react';
import { ServerGridConfig } from '../../../../config/GridConfig';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { ServerSideRowModelModule } from 'ag-grid-enterprise';
import { ModuleRegistry } from '@ag-grid-community/core';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);

	const { openEditModal, openDeleteModal } = props;
	const { TOURPACKAGECATEGORY } = useStore();
	const ActionRenderer = (props) => {
		return (
			<div className="action-column">
				<Button
					type="text"
					title={'Edit'}
					className="editIcon"
					onClick={() => {
						TOURPACKAGECATEGORY.ReadCategory(props.data.id);
						openEditModal();
					}}
				>
					<FontAwesomeIcon icon={faPencilAlt} />
				</Button>
				<Button
					type="text"
					title={'Delete'}
					className="deleteIcon"
					onClick={() => {
						openDeleteModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faTrashAlt} color={'red'} />
				</Button>
			</div>
		);
	};

	const colDefs = [
		{
			headerName: 'Category Name',
			field: 'name',
			minWidth: 140,
			width: 140,
			sort: 'asc',
		},
		{
			headerName: 'Sort Order',
			field: 'sortOrder',
			minWidth: 140,
			width: 140,
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 120,
			width: 120,
		},
	];
	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container
		>
			<AgGridReact
				onGridReady={TOURPACKAGECATEGORY.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				components={{
					ActionRenderer,
					openEditModal,
					openDeleteModal,
				}}
			/>
		</div>
	);
});

export default ListComponent;
